
import type { StoreState } from "@/store/useStore";

type ChatContext = Partial<Pick<StoreState, 'currentGoldPrice' | 'currentSilverPrice' | 'dealers'>>;

export function generateFallbackResponse(question: string, context: ChatContext): string {
    const lowerCaseQuestion = question.toLowerCase();

    if (lowerCaseQuestion.includes("prezzo") && lowerCaseQuestion.includes("oro")) {
        if (context.currentGoldPrice) {
            return `Il prezzo attuale dell'oro è di €${context.currentGoldPrice.price.toFixed(2)} al grammo.`;
        }
        return "Sto recuperando il prezzo dell'oro, un momento...";
    }

    if (lowerCaseQuestion.includes("prezzo") && lowerCaseQuestion.includes("argento")) {
        if (context.currentSilverPrice) {
            return `Il prezzo attuale dell'argento è di €${context.currentSilverPrice.price.toFixed(2)} al grammo.`;
        }
        return "Sto recuperando il prezzo dell'argento, un momento...";
    }

    if (lowerCaseQuestion.includes("compro oro") || lowerCaseQuestion.includes("dealer")) {
        if (context.dealers && context.dealers.length > 0) {
            return `Abbiamo ${context.dealers.length} compro oro partner. I migliori sono: ${context.dealers.slice(0, 3).map(d => d.name).join(', ')}.`;
        }
        return "Sto cercando i compro oro nella tua zona...";
    }

    return "Non ho capito la domanda. Puoi riformularla? Posso darti informazioni sui prezzi di oro e argento e sui compro oro affiliati.";
}
